module.exports = __webpack_public_path__ + "img/logo-white.71d287ef.png";